<template>
  <DoubleColumn>
    <template #header>
      <section class="sm:flex sm:items-center sm:justify-between">
        <div class="sm:flex sm:space-x-5">
          <h1 class="text-3xl font-bold text-white">
            So wird dein Podcast bei uns angelegt
          </h1>
        </div>
      </section>
    </template>
    <template #left>
      <section v-if="resource">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-2 py-5 sm:px-6">
              <PodcastForm :resource="resource" :errors="errors" />
            </div>
          <div class="px-6 pb-6 divide-y divide-gray-200">
            <div class="flex justify-end">
              <CancelButton @click="onCancel" class="mr-2">
                Zur&uuml;ck
              </CancelButton>
              <SubmitButton @click="onSubmit">
                Stimmt alles so
              </SubmitButton>
            </div>
          </div>
        </div>
      </section>
      <section v-else="resource">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            Da hat etwas nicht richtig geklappt...
            Bitte probiere es noch einmal.
          </div>
          <div class="px-6 pb-6 divide-y divide-gray-200">
            <div class="flex justify-end">
              <CancelButton @click="onCancel" class="mr-2">
                Wiederholen...
              </CancelButton>
            </div>
          </div>
        </div>
      </section>
    </template>
    <template #right>
      <section>
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            <StepWizard :step="1" />
          </div>
        </div>
      </section>
    </template>
  </DoubleColumn>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useOnboardingRouter } from '@/router/routers';
import { useRetrieveResource } from '@/client/actions';
import { useUpdateResource } from '@/client/actions';
import { useRemoveResource } from '@/client/actions';

const props = defineProps({id: String});
const router = useOnboardingRouter();

const parent = computed(() => props.id);
const target = computed(() => '/api/podcasts/' + parent.value);
const updateTarget = computed(() => '/api/podcasts/' + parent.value);

const { resource, retrieve, retrieving } = useRetrieveResource(target);
const retrieveTarget = useUpdateResource(updateTarget, resource);

const { update, updating, errors, message, success } = retrieveTarget;
const { remove } = useRemoveResource(target);

const backwards = () => router.create();
const next = (parent) => router.profile(parent);

const onCancel = () => remove(backwards);
const onSubmit = () => update(next);

const onMount = onMounted(() => retrieve());
</script>
